import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";
import { MIRROR_PRIORITIES } from "store/modals/slice";

type Filter = {
  value: string | number;
  label: string;
};

interface Props {
  filterByTitle: string;
  filterByIsActive: { value: string; label: string }[];
  filterByType: string[];
  onFilterSearchByTitle: (e: string) => void;
  onFilterByIsActive: (e: string) => void;
  onFilterByType: (e: { value: string; label: string }[]) => void;
  onClearFilter: () => void;
  handleApply: () => void;
  disabled?: boolean;
}
const SchedulerFilter: React.FC<Props> = ({
  filterByTitle,
  filterByIsActive,
  filterByType,
  onFilterSearchByTitle = () =>{},
  onFilterByIsActive = () => {},
  onFilterByType = () => { },
  onClearFilter = () => {},
  handleApply = () => { },
  disabled
}) => {
  const { t } = useTranslation();

  const handleApplyFilters = () => {
    handleApply();
  };

  const handleClearFilters = () => {
    onFilterSearchByTitle("");
    onFilterByIsActive("");
    onFilterByType([]);
    handleApply();
  };
  
  const handleFilterByActive = (
    e: { value: string | number; label: string }[]
  ) => {
    return;
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      search={filterByTitle}
      onSearch={onFilterSearchByTitle}
      placeholder={t("searchByTitle")}
      disabled={disabled}
      filterItems={[
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],
          activeItems: [],
          handleApply: handleFilterByActive,
        },
      ]}
    />
  );
};

export default SchedulerFilter;
